// extracted by mini-css-extract-plugin
export default {"blue":"#00a9e0","grid":"Custom_grid__OdQdw","outlined":"Custom_outlined__nkLYW","underlined":"Custom_underlined__Iwrex"};